import { render } from "./AllMainPage.vue?vue&type=template&id=2f3515e4&scoped=true"
import script from "./AllMainPage.vue?vue&type=script&lang=js"
export * from "./AllMainPage.vue?vue&type=script&lang=js"

import "./AllMainPage.vue?vue&type=style&index=0&id=2f3515e4&lang=css"
import "./AllMainPage.vue?vue&type=style&index=1&id=2f3515e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f3515e4"]])

export default __exports__